module.exports = __webpack_public_path__ + "img/f-3.jpg";